import { Component } from '@angular/core';

@Component({
  selector: 'navaar-traingles-icon',
  template: `
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 15">
    <path id="Polygon_5" data-name="Polygon 5" d="M10.438,1.952a2,2,0,0,1,3.123,0l7.839,9.8A2,2,0,0,1,19.839,15H4.161A2,2,0,0,1,2.6,11.751Z" transform="translate(24 15) rotate(180)" [attr.fill]="color"/>
  </svg>
  `,
  styles: []
})
export class TrainglesIconComponent {
  public color: string = '#28272e';
  constructor() { }
}
